<template>
  <modal
    :name="modalName"
    height="auto"
    width="900"
    :scrollable="true"
    :clickToClose="false"
    @before-open="loadDependencias"
  >
    <CloseModal :close="closeModal" />
    <div class="modalbox">
      <div class="modalbox-content">
        <v-stepper v-model="step">
          <v-stepper-header>
            <template v-for="(step, index) in steps">
              <v-stepper-step :step="index + 1" editable>
                <div
                  :class="{ message: errors.includes(index + 1) }"
                  class="ml-1"
                >
                  {{ step.name }}
                  <small v-if="step.opcional">Opcional</small>
                </div>
              </v-stepper-step>

              <!-- Adiciona divider entre os steps, exceto o último -->
              <v-divider v-if="index < steps.length - 1"></v-divider>
            </template>
          </v-stepper-header>

          <StepsFormComissao
            :form="form"
            :step="step"
            :dimensoes="dimensoes"
            :regioesRepresentantes="regioesRepresentantes"
          />
        </v-stepper>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" v-on:click="backStep()" class="btn btn-primary">
        Voltar
      </button>
      <button type="button" v-on:click="nextStep()" class="btn btn-primary">
        Próximo
      </button>
      <button
        type="button"
        :disabled="isDisabledConfirm"
        v-on:click="handleSubmit()"
        class="btn btn-success"
      >
        Concluir
      </button>
      <button type="button" class="btn btn-secondary" v-on:click="closeModal">
        Fechar
      </button>
    </div>
  </modal>
</template>
<script>
import { get, post, put } from "@/helpers/apiRequest";
import StepsFormComissao from "./StepsFormComissao/StepsFormComissao.vue";
import CloseModal from "../../../components/CloseModal.vue";
import { isEmpty } from "lodash";

export default {
  name: "ModalGrupoComissao",
  props: ["close", "currentItem"],
  components: { CloseModal, StepsFormComissao },
  data() {
    return {
      modalName: "ModalGrupoComissao",
      colaboradorOrigem: null,
      colaboradorDestino: null,
      valorTransferencia: 0,
      descricao: null,
      errors: [],
      loading: false,
      dimensoes: [],
      regioesRepresentantes: [],
      isDisabledConfirm: true,
      step: 1,
      steps: [
        { name: "Informações Gerais", opcional: false },
        { name: "Restrições", opcional: true },
        { name: "Segmentos", opcional: true },
        { name: "Produtos", opcional: true },
        { name: "Regras", opcional: false },
      ],
      form: {
        nome: "",
        prioridade: 1,
        ativo: 1,
        aplicacallcenter: 0,
        aplicafv: 0,
        restricoes: [],
        dimensoes: [],
        mixProdutos: [],
        regras: [],
      },
    };
  },
  methods: {
    validationSteps(stepValidate) {
      switch (stepValidate) {
        case 1:
          // Validação de Informações gerais
          if (!this.form.nome) {
            return false;
          }
          if (this.form.aplicafv === 0 && this.form.aplicacallcenter === 0) {
            return false;
          }
          if (!this.form.prioridade) {
            return false;
          }

          return true;
          break;
        case 5:
          // Validação de Range de Comissões
          if (this.form.regras.length === 0) {
            return false;
          }
          break;
        default:
          return true;
          break;
      }
      return true;
    },
    getValidations() {
      let errorList = [];
      let isDisabled = false;

      this.steps.forEach((value, index) => {
        if (value.opcional === false && !this.validationSteps(index + 1)) {
          isDisabled = true;
          if (index + 1 < this.step || this.steps.length === this.step) {
            errorList.push(index + 1);
          }
        }
      });

      this.errors = errorList;
      this.isDisabledConfirm = isDisabled;
    },
    backStep() {
      if (this.step > 1) {
        this.step = Number(this.step) - 1;
      }
    },
    nextStep() {
      if (this.step < 6) {
        this.step = Number(this.step) + 1;
      }
    },
    closeModal() {
      this.resetDados();
      this.$modal.hide(this.modalName);
      this.currentItem = {};
      this.close();
    },
    resetDados() {
      this.step = 1;
      this.errors = [];
      this.form = {
        nome: "",
        prioridade: 1,
        ativo: 1,
        aplicacallcenter: 0,
        aplicafv: 0,
        restricoes: [],
        dimensoes: [],
        mixProdutos: [],
        regras: [],
      };
    },
    loadDimensoes() {
      this.loading = true;

      get("/admin/lista-dimensoes")
        .then((json) => {
          this.dimensoes = json;
          this.loading = false;
        })
        .catch(() => (this.loading = false));
    },
    loadRegioesRepresentantes() {
      this.loading = true;

      get("/admin/regioes-representantes")
        .then((json) => {
          this.regioesRepresentantes = json;
          this.loading = false;
        })
        .catch(() => (this.loading = false));
    },
    loadDependencias() {
      this.loadDimensoes();
      this.loadRegioesRepresentantes();
    },

    handleSubmit() {
      if (this.form.id) {
        this.update(this.form);
        return;
      }
      this.create(this.form);
    },
    create(item) {
      this.loading = true;

      post("/admin/grupo-comissao", item)
        .then((json) => {
          this.closeModal();
        })
        .catch((err) => {
          this.loading = false;
          this.$swal({
            title: "Falha ao cadastrar",
            text: err.message,
            icon: "error",
          });
        });
    },
    update(item) {
      this.loading = true;

      put(`/admin/grupo-comissao/${item.id}`, item)
        .then((json) => {
          this.closeModal();
        })
        .catch((err) => {
          this.loading = false;
          this.$swal({
            title: "Falha ao atualizar",
            text: err.message,
            icon: "error",
          });
        });
    },
  },
  watch: {
    step: function () {
      this.getValidations();
    },
    form: {
      deep: true,
      handler() {
        this.getValidations();
      },
    },
    currentItem(item) {
      if (isEmpty(item)) {
        this.form = {
          nome: "",
          prioridade: 1,
          ativo: 1,
          aplicacallcenter: 0,
          aplicafv: 0,
          restricoes: [],
          dimensoes: [],
          mixProdutos: [],
          regras: [],
        };
        return;
      }

      this.form = item;
    },
  },
};
</script>
